var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper",
    class: [_vm.breakColumn ? 'wrapper-break-' + _vm.breakColumn : null, {
      'wrapper-stretch': _vm.stretch,
      'wrapper-grow': _vm.grow,
      'has-break-reverse': _vm.breakReverse,
      'justify-start': _vm.left,
      'justify-center': _vm.center,
      'justify-between': _vm.between,
      'justify-end': !_vm.left && !_vm.center && !_vm.between
    }]
  }, [_vm._t("default", null, {
    "column": _vm.column
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }